import { motion } from "framer-motion";
import { Star } from "lucide-react";

export default function SocialProof({ testid = "social-proof" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4"
      data-testid={testid}
    >
      <div className="flex items-center gap-1" aria-label="Note 4.8 sur 5 étoiles">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            className="w-4 h-4 fill-[#F5C242] text-[#F5C242]"
            strokeWidth={0}
          />
        ))}
      </div>
      <div className="flex items-center gap-2 text-sm text-white/70 font-medium">
        <span className="text-white font-bold">4.8</span>
        <span className="text-white/40">•</span>
        <span>+10 000 utilisateurs</span>
      </div>
    </motion.div>
  );
}
